const mockViewActivities = [
    {
        avatar: "R",
        title: "Puppy Pampering Patrol",
        image: "assets/dogs.jpg",
        description:
            "Spend a day at the local animal shelter giving belly rubs, playing fetch, and spreading love to furry friends in need.",
        date: "May 23, 2017",
    },
    {
        avatar: "P",
        title: "Trash Bash Crew",
        image: "assets/trash.jpg",
        description:
            "Gear up with gloves and trash bags for a neighborhood cleanup extravaganza. Turn picking up litter into a fun competition with prizes for the most unusual finds!",
        date: "June 15, 2018",
    },
    {
        avatar: "S",
        title: "Picnic with Seniors",
        image: "assets/seniors.jpg",
        description:
            "Organize a delightful picnic in the park for elderly residents of a nursing home. Share stories, laughter, and maybe even a game of bingo or two.",
        date: "April 1, 2019",
    },
    {
        avatar: "W",
        title: "Garden Guardians",
        image: "assets/gardens.jpg",
        description:
            "Green thumbs unite! Help spruce up community gardens, planting flowers, weeding, and nurturing green spaces for everyone to enjoy.",
        date: "September 14, 2016",
    },
];

export default mockViewActivities;
